import axiosInstance from "../api";
import { GET_FILTER } from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getFilter = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`filter?type=${type}`);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTER, filterdata: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getFilterwithcategory =
  (type, category_id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `filter?type=${type}&category_id=${category_id}`
      );
      if (response?.data?.status) {
        dispatch({ type: GET_FILTER, filterdata: response?.data?.response });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const getFilterwithPosttype =
  (type, sortposttype) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `filter?type=${type}&post_type=${sortposttype}`
      );
      if (response?.data?.status) {
        dispatch({ type: GET_FILTER, filterdata: response?.data?.response });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };
